import { createSlice } from '@reduxjs/toolkit';
const initialState = {
    diffs: {},
    viewMode: 'side-by-side',
};
const diffSlice = createSlice({
    name: 'diff',
    initialState,
    reducers: {
        setDiff(state, action) {
            state.diffs[action.payload.key] = action.payload.result;
        },
        clearDiff(state, action) {
            delete state.diffs[action.payload];
        },
        setViewMode(state, action) {
            state.viewMode = action.payload;
        },
    },
});
export const { setDiff, clearDiff, setViewMode } = diffSlice.actions;
export default diffSlice.reducer;
//# sourceMappingURL=diffSlice.js.map